
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { IAppExtensionPage } from '@msx/platform-services';
import { Extension } from '../core/components'
import {
  NotFound,
} from './pages'
import { Redirect } from 'react-router';
export interface Props {
  extensonPages: IAppExtensionPage[];
}

export const Routes: (React.FC<Props>) = (props) => {
  const { extensonPages } = props;

  const renderMain = (): JSX.Element => {
    return (
      <Switch>
        <Route exact path="/" render={() => (
          <Redirect to="/dealAssistance" />
        )} />
        {extensonPages.map((page) => {
          return <Route
            key={page.name}
            name={page.name}
            path={'/' + page.routePath}
            render={(): React.ReactElement => <Extension componentKey={page.key} searchText={window.location.search} />}
          />;
        })}

        <Route component={NotFound} />
      </Switch>
    );
  }

  return renderMain();

}